import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppraisalAttachment, AppraisalDetailsModelForCM } from "../../all_Interfaces";


interface InitialState {
    data: AppraisalAttachment[],
    error: string,
    loading: boolean
}
const initialState: InitialState =
{
    data: [] as AppraisalAttachment[],
    error: '',
    loading: false
}

const addNewAttachmentSlice = createSlice({
    name: "AddNewAttachments",
    initialState,
    reducers: {
        addNewAttachments(state, action: PayloadAction<AppraisalAttachment[]>) {
            state.data = action.payload;
        },
    },
});

export const { addNewAttachments } = addNewAttachmentSlice.actions;

export default addNewAttachmentSlice.reducer;